<style scoped="scoped" lang="scss"></style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/fine/bi/report/list?biType=1" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()">
			</el-button> -->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="inGo(makeUrl1(scope.row.route))">
              {{ $t('neibudakai') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="outGo(makeUrl2(scope.row.route))">
              {{ $t('waibudakai') }}
            </el-button>
          </el-col>
        </el-row>
      </template>

    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">

    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_report_bi_index',
  components: {
  },

  data() {
    return {
      // orgList: [],
      list: [],
      columns: [
        {
          label: 'xuhao',
          prop: 'id',
        },
        {
          label: 'baobiao',
          prop: 'name'
        },

        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },

  methods: {

    getParameter(query, param) {
      var iLen = param.length;
      var iStart = query.indexOf(param);
      if (iStart == -1) return "";
      iStart += iLen + 1;
      var iEnd = query.indexOf("&", iStart);
      if (iEnd == -1) return decodeURIComponent(query.substring(iStart));
      return decodeURIComponent(query.substring(iStart, iEnd));
    },
    makeUrl1(str) {
      return str
    },
    makeUrl2(str) {
      let url = this.getParameter(str, 'url')
      url = decodeURIComponent(url)
      if (url.indexOf('?') == -1) {
        url += '?_='
      }
      url = url + '&ssoToken=' + localStorage.getItem('ssoToken');


      return url
    },
    inGo(url) {
      //内部跳转
      this.$router.push(url);
    },
    outGo(url) {
      var w = window.open(url, '_blank')
    },
  }
};
</script>
